import { ApiClient } from '@/infra/api-client'

export interface TrustpilotPayload {
  data: string
  iv: string
  tag: string
  sig: string
}

export class TrustpilotApi extends ApiClient {
  getPayload(reference: string, signal?: AbortSignal) {
    return this._post<{ reference: string }, TrustpilotPayload>(
      '__trustpilot/payload',
      { reference },
      undefined,
      { signal },
    )
  }
}
